export const workOrderMixin = {
    data() {
        return {
            statuses: ["plan", "in_progress", "done", "confirmed", "cancelled"],
        };
    },
    methods: {
        formatStatus(word) {
            word = word.replaceAll("_", " ");
            return this.t(word.charAt(0).toUpperCase() + word.slice(1));
        },
        statusColor(status) {
            if (status === "plan") {
                return "gray";
            } else if (status === "in_progress") {
                return "blue";
            } else if (status === "done") {
                return "green";
            } else if (status === "confirmed") {
                return "purple";
            } else if (status === "cancelled") {
                return "red";
            }
        },
        formatDayDiff(dayDiff) {
            if (typeof dayDiff == "number") {
                if (dayDiff === 0) {
                    return this.t("Today");
                } else if (dayDiff === -1) {
                    return this.t("Yesterday");
                } else if (dayDiff === 1) {
                    return this.t("Tomorrow");
                } else if (dayDiff > 1) {
                    return `${dayDiff} ${this.t("days")}`;
                } else {
                    return `${Math.abs(dayDiff)} ${this.t("days ago")}`;
                }
            }

            return "-";
        },
        dayDiffColor(dayDiff) {
            if (typeof dayDiff == "number") {
                if (dayDiff === 0) {
                    return "orange";
                } else if (dayDiff === -1) {
                    return "#ff0000";
                } else if (dayDiff === 1) {
                    return "green";
                } else if (dayDiff > 1) {
                    return `#1b4900`;
                } else {
                    return `#8c0000`;
                }
            }

            return "-";
        },
        formatDate(inputDate) {
            const parsedDate = new Date(inputDate);
            if (isNaN(parsedDate.getTime())) {
                return inputDate;
            }
            const day = parsedDate.getDate().toString().padStart(2, "0");
            const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
            const year = parsedDate.getFullYear();
            return `${day}.${month}.${year}`;
        },
        formatLineNumber(lineNumber) {
            if (!lineNumber) return;

            return lineNumber
                .split("+")
                .map((part) => {
                    const match = part.match(/^(.*)_(\d+)$/);
                    let textPart, numberPart;

                    if (match) {
                        textPart = match[1].replace(/_/g, " ");
                        textPart = textPart.charAt(0).toUpperCase() + textPart.slice(1);
                        numberPart = match[2];
                    } else {
                        textPart = part.charAt(0).toUpperCase() + part.slice(1);
                        numberPart = "";
                    }

                    let translatedText = this.t(textPart);

                    translatedText = translatedText.replace(/\bpakkimine\b\s*/gi, "").trim();

                    return numberPart ? `${translatedText} ${numberPart}` : translatedText || part;
                })
                .join(" + ");
        },
        calculateActualDuration(productionDate, exchangeReportStartTime, exchangeReportEndTime, inFloat = false) {
            try {
                const date = productionDate ? new Date(productionDate) : new Date();

                const startParts = exchangeReportStartTime.split(":").map(Number);
                const endParts = exchangeReportEndTime.split(":").map(Number);

                const start = new Date(date);
                start.setHours(startParts[0], startParts[1], 0, 0);

                const end = new Date(date);
                end.setHours(endParts[0], endParts[1], 0, 0);

                // handle night shift
                if (end < start) {
                    end.setDate(end.getDate() + 1);
                }

                // duration in milliseconds
                const totalDuration = end - start;

                if (inFloat) {
                    const actualDuration = totalDuration / 1000 / 60;
                    return {
                        actual_duration: actualDuration,
                        start_date: start,
                        end_date: end,
                    };
                }

                const hours = Math.floor(totalDuration / 3600000);
                const minutes = Math.floor((totalDuration % 3600000) / 60000);
                const seconds = Math.floor((totalDuration % 60000) / 1000);
                return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(
                    seconds
                ).padStart(2, "0")}`;
            } catch (e) {
                console.error(`calculateActualDuration: ${e}`);
                return null;
            }
        },
    },
};
